import React from 'react';

interface ITreadingUpIcon {
  size?: number;
  fill?: string;
}

const TreadingUpIcon: React.FC<ITreadingUpIcon> = props => {
  const { size = 16, fill = '#E92C2C' } = props;
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.26683 12L1.3335 11.0667L6.26683 6.1L8.9335 8.76667L12.4002 5.33333H10.6668V4H14.6668V8H13.3335V6.26667L8.9335 10.6667L6.26683 8L2.26683 12Z"
        fill={fill}
      />
    </svg>
  );
};

export default TreadingUpIcon;
